export const getStatusColor = (status: string): string => {
    switch (status) {
        case "approved":
        case "sent":
        case "delivered":
            return "#4caf50";
        case "rejected":
        case "canceled":
            return "#f44336";
        case "pending":
        case "queued":
        case "sending":
            return "#ff9800";
        case "uncertain":
        case "error":
            return "#f44336";
        case "expired":
            return "#9e9e9e";
        default:
            return "#9e9e9e";
    }
};

export const getStatusIcon = (status: string): string => {
    switch (status) {
        case "approved":
        case "sent":
        case "delivered":
            return "✓";
        case "rejected":
        case "canceled":
            return "✗";
        case "pending":
        case "queued":
        case "sending":
            return "⏳";
        case "uncertain":
            return "?";
        case "error":
            return "!";
        case "expired":
            return "⌛";
        default:
            return "○";
    }
};

export const formatDate = (dateString: string): string => {
    if (!dateString) return "Pending";
    return new Date(dateString).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

export type StageStatus =
    | "approved"
    | "rejected"
    | "pending"
    | "inProgress"
    | "canceled";

export const getStageStatus = (
    stage: Compleo.JobApproval.stageWithApproversStatus,
    jobStatus: CompleoShared.Common.JobStatus
): StageStatus => {
    const approvers = stage.approverStatus || [];
    const completedApprovers = approvers.filter(
        (a) => a.actionResult?.status === "approved"
    );
    const rejectedApprovers = approvers.filter(
        (a) => a.actionResult?.status === "rejected"
    );

    if (rejectedApprovers.length > 0) {
        return "rejected";
    }
    if (
        completedApprovers.length === approvers.length &&
        approvers.length > 0
    ) {
        return "approved";
    }
    if (completedApprovers.length > 0 && stage.approvalLogic.value === "or") {
        return "approved";
    }

    if (
        jobStatus === "jobApprovalRejected" ||
        jobStatus === "jobApprovalExpired"
    ) {
        return "canceled";
    }
    if (completedApprovers.length > 0 && stage.approvalLogic.value === "and") {
        return "inProgress";
    }

    return "pending";
};
